// Floating weed leaves JS
(function(){
  try{
    var count = 6;
    var container = document.body;
    for (var i=0;i<count;i++){
      var leaf = document.createElement('img');
      leaf.src = 'https://i.imgur.com/8YQ9Yg1.png'; // weed leaf icon
      leaf.className = 'leaf';
      leaf.style.left = (5 + Math.random()*90) + '%';
      leaf.style.bottom = (-40 - Math.random()*60) + 'px';
      leaf.style.animationDelay = (Math.random()*8) + 's';
      leaf.style.animationDuration = (10 + Math.random()*8) + 's';
      container.appendChild(leaf);
    }
  } catch(e){
    console && console.error && console.error(e);
  }
})();


// Floating review popup logic
document.addEventListener("DOMContentLoaded", function() {
  try {
    var container = document.getElementById("hh-review-pop");
    if (!container) return;

    var txt = container.querySelector(".hh-review-pop-text");
    var closeBtn = container.querySelector(".hh-review-pop-close");

    var reviews = [
      "🔥 Mini bong rips harder than expected. Travel case is clutch! — Ryan M.",
      "💨 The car rolling tray is genius. No crumbs on my seat anymore 😂 — Maria G.",
      "⭐ Grinder + tray combo is 10/10. Print is 🔥 — T.J.",
      "🧢 Highway beanie fits perfect + looks dope. — Jaylen D.",
      "☕ Mug is high quality + dishwasher safe. — Maddie B.",
      "💚 Silicone bong hits smooth + cleans easy. — Chris A.",
      "⚙️ Glow grinder spins beautifully + looks sick on my desk. — Eli W.",
      "🌱 Cone bundle burns slow + ships fast. — Haley R.",
      "🚗 Cup-holder rolling tray is literally perfect. — Ricky L.",
      "🔥 Hoodie quality surprised me — super thick. — Sasha P.",
      "🌿 Metal pipe set was a steal + accessories included. — Adam W.",
      "🔮 Tarot tray actually became my daily driver 😂 — Nina T.",
      "🍓 Strawberry tray is cute AF + functional — Lynsey F.",
      "💨 Silicone/glass bong hits smoother than my rig. — Zack J."
    ];

    var idx = 0;
    var closed = false;

    function showPopup() {
      if (closed) return;
      if (!txt) return;
      txt.textContent = reviews[idx % reviews.length];
      container.style.display = "block";
      idx++;
    }

    function startRotation() {
      showPopup();
      setInterval(function() {
        if (closed) return;
        showPopup();
      }, 12000);
    }

    setTimeout(startRotation, 6000);

    if (closeBtn) {
      closeBtn.addEventListener("click", function() {
        closed = true;
        container.style.display = "none";
      });
    }
  } catch (e) {
    console && console.error && console.error(e);
  }
});
